import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://kzdyjfuaiffrzeimeksf.supabase.co";
const supabaseKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imt6ZHlqZnVhaWZmcnplaW1la3NmIiwicm9sZSI6ImFub24iLCJpYXQiOjE2NzkyMDA3OTQsImV4cCI6MTk5NDc3Njc5NH0.KWpqWEkpsKS9B23C1ftZH7poxxTFCzVw20LXSaYnUPA";
const supabase = createClient(supabaseUrl, supabaseKey);

export default supabase;
